import DescmoocsScreen from './containers/descmoocsScreen'

export {default as DescmoocsScreenLayout} from './components/descmoocsScreenLayout'

export default DescmoocsScreen
